// The execution row shape, shared by the table and its cells.

import PropTypes from 'prop-types';

export const executionAttributesPropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  integration_id: PropTypes.string,
  integration_name: PropTypes.string,
  x_decisiv_trace_id: PropTypes.string,
  configured_integration_id: PropTypes.string,
  location_name: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  status: PropTypes.string,
  source: PropTypes.string,
  trigger_type: PropTypes.string,
  time_taken: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  start_date: PropTypes.string,
  error_summary: PropTypes.shape({
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        detail: PropTypes.string,
        status: PropTypes.number,
      }),
    ),
  }),
  retry_count: PropTypes.number,
});

export const executionPropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  attributes: executionAttributesPropTypes,
});
